import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { useDispatch as dispatch } from "react-redux";
import { SET_STARTUP_DETAILS } from "../store/actions";
import moment from "moment";
import { checkForAuthorization, checkForEmail } from "utils/index";

export const UpdateStartup = ({ setProgress, startup_id }) => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/editStartup/${startup_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'multipart/form-data'
                },
                data: payload,
                onUploadProgress: (data) => {
                    setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const FetchStartupDetails = (slug = "mymandi") => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-FetchStartupDetails-FetchStartupDetails-FetchStartupDetails-fetch'],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/startup-details-by-slug/${slug}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            const savedData = data.data;
            // console.log(data,"new Data")
            return { data: savedData?.data[0], status: savedData?.statusCode }
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchProfileDetails = ({ investor_id }) => {

    return useQuery(
        ['master-FetchProfileDetails-FetchProfileDetails-FetchProfileDetails-fetch' + investor_id, investor_id],
        () => {
            if (!investor_id) {
                return Promise.resolve({ data: { data: [] }, status: "No Data" });
            }
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/user-info-v2/${investor_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            const savedData = data.data.data[0];
            const personal_information = savedData?.personal_information
            const profile_picture = savedData?.profile_picture
            const preferences = savedData?.preferences
            const investment_size_preference = savedData?.investment_size_preference
            const previous_investment_experience = savedData?.previous_investment_experience
            const startups = savedData?.startups
            const whatsapp_notifications = savedData?.whatsapp_notifications
            const linkedIn_profile = savedData?.linkedIn_profile
            let date = ""
            let month = ""
            let year = ""
            if (personal_information?.dob) {
                let dateOfBirth = moment(personal_information?.dob).format("MM-DD-YYYY")
                month = dateOfBirth.split("-")[0]
                date = dateOfBirth.split("-")[1]
                year = dateOfBirth.split("-")[2]
            }
            let starupArray = []
            if (startups) {
                let modifiedStartups = []
                if (startups?.length > 0) {
                    startups.map((item, index) => {
                        modifiedStartups.push({
                            id: index + 1,
                            startup_name: item.startup_name,
                            startup_url: item.startup_url,
                            edit: false
                        })
                    })
                } else {
                    modifiedStartups.push({
                        id: 0,
                        startup_name: null,
                        startup_url: null,
                        edit: true
                    })
                }
                starupArray = [...starupArray, ...modifiedStartups]
            } else {
                starupArray.push(
                    {
                        id: 0,
                        startup_name: null,
                        startup_url: null,
                        edit: true
                    }
                )
            }
            const savedValues = {
                // step 1
                invite_link: savedData?.invite_link,
                investor_type: savedData?.investor_type ? String(savedData?.investor_type) : '',
                first_name: personal_information?.first_name ? String(personal_information?.first_name) : '',
                last_name: personal_information?.last_name ? String(personal_information?.last_name) : '',
                title: personal_information?.title ? String(personal_information?.title) : '',
                dd: date,
                mm: month,
                yyyy: year,
                organization_name: savedData?.personal_information?.organization_name || "",
                phone_number: savedData?.personal_information?.phone_number || "",
                country_code: savedData?.personal_information?.country_code || "91",
                organization_website: savedData?.personal_information?.organization_website ? (String(savedData?.personal_information?.organization_website)?.startsWith("https://") ? String(savedData?.personal_information?.organization_website)?.slice(8) : savedData?.personal_information?.organization_website) : '',
                bio: personal_information?.bio || '',
                date_of_birth: personal_information?.dob ? moment(personal_information?.dob).format("DD-MMM-YYYY") : null,
                custom_image_url: profile_picture?.profile_path?.trim()?.length > 0 ? profile_picture?.profile_path : null,
                website_logo: profile_picture?.website_logo_url?.trim()?.length > 0 ? profile_picture?.website_logo_url : null,
                avatar_selected: profile_picture?.custom_image_url?.trim()?.length > 0 ? null : profile_picture?.avatar_selected ? profile_picture?.avatar_selected : null,
                profile_path: profile_picture?.profile_path?.trim()?.length > 0 ? profile_picture?.profile_path : null,
                country_id: personal_information?.country_id ? personal_information?.country_id : null,
                state_id: personal_information?.state_id ? personal_information?.state_id : null,
                city_id: personal_information?.city_id ? personal_information?.city_id : null,
                country_name: savedData?.country ? savedData?.country : null,
                state_name: savedData?.state ? savedData?.state : null,
                city_name: savedData?.city ? savedData?.city : null,
                category_id: preferences?.category_id ? preferences?.category_id : null,
                sector_id: preferences?.preferred_sectors ? preferences?.preferred_sectors : [],
                sector_type: preferences?.sector_type ? preferences?.sector_type : "Multiple",
                investment_size: investment_size_preference?.investment_size ? investment_size_preference?.investment_size : null,
                min: investment_size_preference?.min_amount ? investment_size_preference?.min_amount : null,
                max: investment_size_preference?.max_amount ? investment_size_preference?.max_amount : null,
                investment_amount_type: investment_size_preference?.currency ? investment_size_preference?.currency : null,
                stage_id: preferences?.startup_stages ? preferences?.startup_stages : [],
                business_model_id: preferences?.business_model_id ? preferences?.business_model_id : [],
                business_model_type: preferences?.business_model_type ? preferences?.business_model_type : "Multiple",
                investment_count: previous_investment_experience?.investment_count !== null && previous_investment_experience?.investment_count !== undefined && previous_investment_experience?.investment_count !== "null" ? String(previous_investment_experience?.investment_count) : null,
                startups: starupArray,
                enabled: whatsapp_notifications?.enabled ? whatsapp_notifications?.enabled : false,
                whatsapp_number: whatsapp_notifications?.whatsapp_number ? whatsapp_notifications?.whatsapp_number : null,
                phone_code: whatsapp_notifications?.phone_code ? whatsapp_notifications?.phone_code : "91",
                otp_verified: whatsapp_notifications?.otp_verified ? whatsapp_notifications?.otp_verified : false,
                profile_url: linkedIn_profile?.profile_url ? String(linkedIn_profile?.profile_url)?.startsWith("https://") ? String(linkedIn_profile?.profile_url)?.slice(8) : linkedIn_profile?.profile_url : null,
                linkedIn_profile_url: linkedIn_profile?.profile_url ? linkedIn_profile?.profile_url : null,
                public_url: savedData?.slug ? savedData?.slug : (String(personal_information?.first_name + personal_information?.last_name)?.toLowerCase()?.replaceAll(" ", "")?.replace(/[^a-zA-Z0-9]/g, '')),
                isPublicURLVerify: !!(savedData?.slug),
                backrr_base_url: savedData?.backrr_base_url || '',
                linkedin_public_profile: savedData?.linkedin_public_profile != null ? savedData?.linkedin_public_profile : true,
                sector_info: savedData?.sector_info ? savedData?.sector_info : [],
                stage_info: savedData?.stage_info ? savedData?.stage_info : [],
                business_model_info: savedData?.business_model_info ? savedData?.business_model_info : [],
                category_info: savedData?.category_info ? savedData?.category_info : null,
                step: savedData?.step || 1,
                _id: savedData?._id,
                email: savedData?.email,
                partners: savedData?.partner ? savedData?.partner?.length > 0 ? savedData?.partner?.map(item => {
                    return {
                        ...item,
                        name: item?.name || "",
                        linkedin_url:
                            item?.linkedin_url ? String(item?.linkedin_url)?.startsWith("https://") ? String(item?.linkedin_url)?.slice(8) : item?.linkedin_url : null,
                        image: item?.image_url || null,
                        bio: item?.bio || "",
                    }
                }) : [
                    {
                        name: "",
                        linkedin_url: "",
                        image: null,
                        bio: "",
                    }
                ] : [
                    {
                        name: "",
                        linkedin_url: "",
                        image: null,
                        bio: "",
                    }
                ],
                profile_view: savedData?.profile_view != null ? savedData?.profile_view : true,
            }
            if (checkForEmail()) {

            }
            else if (savedData?.email && !savedData?.email?.includes("undefined")) {
                Cookies.set("email", savedData?.email)
            }
            else {
                window.location.href = "/logout";
            }
            savedData?.is_profile_completed && Cookies.set("is_profile_complete", savedData?.is_profile_completed)
            // console.log(savedValues, "savedData?.partners")
            return { data: savedValues, status: savedData?.success }
        },
        refetchOnWindowFocus: false,
        // enabled: Boolean(investor_id),
        cacheTime: 0,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchClaimProfileInvestorDetails = ({ investor_id }) => {

    return useQuery(
        ['master-FetchClaimProfileInvestorDetails-FetchClaimProfileInvestorDetails-FetchClaimProfileInvestorDetails-fetch' + investor_id, investor_id],
        () => {
            if (!investor_id) {
                return Promise.resolve({ data: { data: [] }, status: "No Data" });
            }
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/get-claim-profile-investor/${investor_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            const savedData = data.data.data;
            const savedValues = {...savedData};
            // const personal_information = savedData?.personal_information
            // const profile_picture = savedData?.profile_picture
            // const preferences = savedData?.preferences
            // const investment_size_preference = savedData?.investment_size_preference
            // const previous_investment_experience = savedData?.previous_investment_experience
            // const startups = savedData?.startups
            // const whatsapp_notifications = savedData?.whatsapp_notifications
            // const linkedIn_profile = savedData?.linkedIn_profile
            // let date = ""
            // let month = ""
            // let year = ""
            // if (personal_information?.dob) {
            //     let dateOfBirth = moment(personal_information?.dob).format("MM-DD-YYYY")
            //     month = dateOfBirth.split("-")[0]
            //     date = dateOfBirth.split("-")[1]
            //     year = dateOfBirth.split("-")[2]
            // }
            // let starupArray = []
            // if (startups) {
            //     let modifiedStartups = []
            //     if (startups?.length > 0) {
            //         startups.map((item, index) => {
            //             modifiedStartups.push({
            //                 id: index + 1,
            //                 startup_name: item.startup_name,
            //                 startup_url: item.startup_url,
            //                 edit: false
            //             })
            //         })
            //     } else {
            //         modifiedStartups.push({
            //             id: 0,
            //             startup_name: null,
            //             startup_url: null,
            //             edit: true
            //         })
            //     }
            //     starupArray = [...starupArray, ...modifiedStartups]
            // } else {
            //     starupArray.push(
            //         {
            //             id: 0,
            //             startup_name: null,
            //             startup_url: null,
            //             edit: true
            //         }
            //     )
            // }
            // const savedValues = {
            //     // step 1
            //     invite_link: savedData?.invite_link,
            //     investor_type: savedData?.investor_type ? String(savedData?.investor_type) : '',
            //     first_name: personal_information?.first_name ? String(personal_information?.first_name) : '',
            //     last_name: personal_information?.last_name ? String(personal_information?.last_name) : '',
            //     title: personal_information?.title ? String(personal_information?.title) : '',
            //     dd: date,
            //     mm: month,
            //     yyyy: year,
            //     organization_name: savedData?.personal_information?.organization_name || "",
            //     phone_number: savedData?.personal_information?.phone_number || "",
            //     country_code: savedData?.personal_information?.country_code || "91",
            //     organization_website: savedData?.personal_information?.organization_website ? (String(savedData?.personal_information?.organization_website)?.startsWith("https://") ? String(savedData?.personal_information?.organization_website)?.slice(8) : savedData?.personal_information?.organization_website) : '',
            //     bio: personal_information?.bio || '',
            //     date_of_birth: personal_information?.dob ? moment(personal_information?.dob).format("DD-MMM-YYYY") : null,
            //     custom_image_url: profile_picture?.profile_path?.trim()?.length > 0 ? profile_picture?.profile_path : null,
            //     website_logo: profile_picture?.website_logo_url?.trim()?.length > 0 ? profile_picture?.website_logo_url : null,
            //     avatar_selected: profile_picture?.custom_image_url?.trim()?.length > 0 ? null : profile_picture?.avatar_selected ? profile_picture?.avatar_selected : null,
            //     profile_path: profile_picture?.profile_path?.trim()?.length > 0 ? profile_picture?.profile_path : null,
            //     country_id: personal_information?.country_id ? personal_information?.country_id : null,
            //     state_id: personal_information?.state_id ? personal_information?.state_id : null,
            //     city_id: personal_information?.city_id ? personal_information?.city_id : null,
            //     country_name: savedData?.country ? savedData?.country : null,
            //     state_name: savedData?.state ? savedData?.state : null,
            //     city_name: savedData?.city ? savedData?.city : null,
            //     category_id: preferences?.category_id ? preferences?.category_id : null,
            //     sector_id: preferences?.preferred_sectors ? preferences?.preferred_sectors : [],
            //     sector_type: preferences?.sector_type ? preferences?.sector_type : "Multiple",
            //     investment_size: investment_size_preference?.investment_size ? investment_size_preference?.investment_size : null,
            //     min: investment_size_preference?.min_amount ? investment_size_preference?.min_amount : null,
            //     max: investment_size_preference?.max_amount ? investment_size_preference?.max_amount : null,
            //     investment_amount_type: investment_size_preference?.currency ? investment_size_preference?.currency : null,
            //     stage_id: preferences?.startup_stages ? preferences?.startup_stages : [],
            //     business_model_id: preferences?.business_model_id ? preferences?.business_model_id : [],
            //     business_model_type: preferences?.business_model_type ? preferences?.business_model_type : "Multiple",
            //     investment_count: previous_investment_experience?.investment_count !== null && previous_investment_experience?.investment_count !== undefined && previous_investment_experience?.investment_count !== "null" ? String(previous_investment_experience?.investment_count) : null,
            //     startups: starupArray,
            //     enabled: whatsapp_notifications?.enabled ? whatsapp_notifications?.enabled : false,
            //     whatsapp_number: whatsapp_notifications?.whatsapp_number ? whatsapp_notifications?.whatsapp_number : null,
            //     phone_code: whatsapp_notifications?.phone_code ? whatsapp_notifications?.phone_code : "91",
            //     otp_verified: whatsapp_notifications?.otp_verified ? whatsapp_notifications?.otp_verified : false,
            //     profile_url: linkedIn_profile?.profile_url ? String(linkedIn_profile?.profile_url)?.startsWith("https://") ? String(linkedIn_profile?.profile_url)?.slice(8) : linkedIn_profile?.profile_url : null,
            //     linkedIn_profile_url: linkedIn_profile?.profile_url ? linkedIn_profile?.profile_url : null,
            //     public_url: savedData?.slug ? savedData?.slug : (String(personal_information?.first_name + personal_information?.last_name)?.toLowerCase()?.replaceAll(" ", "")?.replace(/[^a-zA-Z0-9]/g, '')),
            //     isPublicURLVerify: !!(savedData?.slug),
            //     backrr_base_url: savedData?.backrr_base_url || '',
            //     linkedin_public_profile: savedData?.linkedin_public_profile != null ? savedData?.linkedin_public_profile : true,
            //     sector_info: savedData?.sector_info ? savedData?.sector_info : [],
            //     stage_info: savedData?.stage_info ? savedData?.stage_info : [],
            //     business_model_info: savedData?.business_model_info ? savedData?.business_model_info : [],
            //     category_info: savedData?.category_info ? savedData?.category_info : null,
            //     step: savedData?.step || 1,
            //     _id: savedData?._id,
            //     email: savedData?.email,
            //     partners: savedData?.partner ? savedData?.partner?.length > 0 ? savedData?.partner?.map(item => {
            //         return {
            //             ...item,
            //             name: item?.name || "",
            //             linkedin_url:
            //                 item?.linkedin_url ? String(item?.linkedin_url)?.startsWith("https://") ? String(item?.linkedin_url)?.slice(8) : item?.linkedin_url : null,
            //             image: item?.image_url || null,
            //             bio: item?.bio || "",
            //         }
            //     }) : [
            //         {
            //             name: "",
            //             linkedin_url: "",
            //             image: null,
            //             bio: "",
            //         }
            //     ] : [
            //         {
            //             name: "",
            //             linkedin_url: "",
            //             image: null,
            //             bio: "",
            //         }
            //     ],
            //     profile_view: savedData?.profile_view != null ? savedData?.profile_view : true,
            // }
            // if (checkForEmail()) {

            // }
            // else if (savedData?.email && !savedData?.email?.includes("undefined")) {
            //     Cookies.set("email", savedData?.email)
            // }
            // else {
            //     window.location.href = "/logout";
            // }
            // savedData?.is_profile_completed && Cookies.set("is_profile_complete", savedData?.is_profile_completed)
            // console.log(savedValues, "savedData?.partners")
            return { data: savedValues, status: savedData?.success }
        },
        refetchOnWindowFocus: false,
        // enabled: Boolean(investor_id),
        cacheTime: 0,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const ClaimInvestorProfile = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/add-claim-invetor-collaborator`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};


export const SavePersonalInfo = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const SaveProfileImage = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/user_profile_image`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'multipart/form-data'
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const SaveStartupInfo = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/save_startup_info`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};

export const SendWhatsappOTP = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/whatsapp-notification`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};

export const VerifyWhatsAppOTP = () => {
    return useMutation((payload) => {
        return axios({
            method: 'post',
            url: `${process.env.REACT_APP_BASE_URL}/investors/verify-whatsapp-otp`,
            headers: {
                Authorization: `Bearer ${checkForAuthorization()}`,
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            },
            data: payload
        });
    }, {
        retry: 0,
        onError: (err) => {
            // Handle the error
            console.error(err);
        },
    });
};
export const VerifyPublicURL = () => {
    return useMutation((payload) => {
        return axios({
            method: 'post',
            url: `${process.env.REACT_APP_BASE_URL}/investors/slug`,
            headers: {
                Authorization: `Bearer ${checkForAuthorization()}`,
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            },
            data: payload
        });
    }, {
        retry: 0,
        onError: (err) => {
            // Handle the error
            console.error(err);
        },
    });
};

export const AddPartners = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/add-partner`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'multipart/form-data'
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const DeletePartnerByID = () => {
    return useMutation(
        ({ payload }) => {
            return axios({
                method: 'delete',
                url: `${process.env.REACT_APP_BASE_URL}/investors/delete-partner`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload
            });
        },
        {
            retry: 0,
            // onSuccess: (data)=>console.log("API successfull"),
            // retry: (failureCount, error)=>{
            //   return RetryOnError(failureCount, error)
            // },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};